function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Social Media / Small / Dark / Instagram Copy");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Home-",
  transform: "translate(-12046.000000, -725.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Social-Media-Copy",
  transform: "translate(11894.000000, 725.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Social-Media-/-Small-/-Dark-/-Linkin",
  transform: "translate(152.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "iconmonstr-linkedin-4"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.5,0 C7.387875,0 0,7.387875 0,16.5 C0,25.612125 7.387875,33 16.5,33 C25.612125,33 33,25.612125 33,16.5 C33,7.387875 25.612125,0 16.5,0 Z M13.75,22 L11,22 L11,13.75 L13.75,13.75 L13.75,22 Z M12.375,12.524875 C11.540375,12.524875 10.8625,11.842875 10.8625,11 C10.8625,10.1585 11.539,9.475125 12.375,9.475125 C13.211,9.475125 13.8875,10.1585 13.8875,11 C13.8875,11.842875 13.209625,12.524875 12.375,12.524875 Z M23.375,22 L20.62775,22 L20.62775,18.066125 C20.62775,15.47975 17.875,15.698375 17.875,18.066125 L17.875,22 L15.125,22 L15.125,13.75 L17.875,13.75 L17.875,15.252875 C19.074,13.030875 23.375,12.865875 23.375,17.381375 L23.375,22 Z",
  id: "Shape",
  fillRule: "nonzero"
}))))));

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Linkedin.d4452dae.svg";
export { ForwardRef as ReactComponent };